import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class PlanForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            NumberOfDays: 0,
            Motivationals: [],
            CurrentMotivational: {
                Key: 0,
                Description: ''
            },
            activitiesCount: 1,
            topics: [],
            activitiesPlan: [],
            model: {
                id: !isNaN(window.location.href.substring(window.location.href.lastIndexOf('/') + 1)) ? window.location.href.substring(window.location.href.lastIndexOf('/') + 1) : 0,
                title: '',
                author: '',
                plNumber: '',
                description: '',
                topics: [],
                numberOfDays: 0,
                photo: '',
                newPhoto: ''
            },
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            activities: [],
            selectedMotivational: {}
        }
    }

    componentDidMount() {
        const dropArea = document.querySelector(".drop_box"),
            buttonFile = dropArea.querySelector("button"),
            input = dropArea.querySelector("input");

        buttonFile.onclick = () => {
            input.click();
        };

        this.GetAllTopicsActive();

        if (this.state.model.id > 0) {
            this.GetPlanEditById();
        }


    }

    async AddOrUpdate() {

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/AddOrUpdatePlan`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ model: data });

            //this.GetActivitiesByPlanForEditByPlanId();
            this.GetMotivationals();
            document.querySelector('#stepTwo').click();
            document.querySelector('#stepOne').click();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Error guardando el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async InsertActivitiesByPlan() {

        var model = [];

        document.querySelectorAll('.activities-input').forEach((e, i) => {
            model.push(
                {
                    PlanId: this.state.model.id,
                    IsMotivational: e.dataset.isMotivational === "true",
                    Day: this.state.selectedMotivational.day,
                    Description: e.value,
                    MotivationalId: e.dataset.isMotivational === "false" ? this.state.selectedMotivational.id : null
                }
            )
        })

        if (!document.querySelector('[data-is-motivational="true"]').value) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Los campos marcados con asterisco (*) son obligatorios.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            body: JSON.stringify(model)
        }
        this.setState({ loading: true });
        const response = await fetch(`Plan/InsertActivitiesByPlan`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.GetMotivationals();
            this.setState({
                alert: {
                    Title: '',
                    Body: 'Las actividades del plan se han guardado con éxito.',
                    Type: 'alert-success',
                    Show: true
                },
                CurrentMotivational: {
                    Key: 0,
                    Description: ''
                }
            });
            document.querySelector('#stepTwo').click();
            document.querySelector('#stepThree').click();
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Error guardando actividades del plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetPlanEditById() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetPlanEditById?planId=${this.state.model.id}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ model: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Usted no cuenta con los permisos para editar este plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetActivitiesByPlanForEditByPlanId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetActivitiesByPlanForEditByPlanId?planId=${this.state.model.id}`, request);

        this.setState({ loading: false, model: this.state.model });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ activitiesPlan: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los temas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetMotivationals() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetMotivationals?planId=${this.state.model.id}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ Motivationals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los motivacionales',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetActivitiesByMotivationalId(motivationalId) {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetActivitiesByMotivationalId?motivationalId=${motivationalId}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ activities: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los motivacionales',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async GetAllTopicsActive() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Topic/GetAllTopicsActive`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ topics: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los temas',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async UpdateStatePlan() {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` }
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/UpdateStatePlan?state=En revisión&planId=${this.state.model.id}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'El plan se ha enviado para revisión',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Error guardando el plan',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    getBase64(file) {
        var context = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            var model = context.state.model;
            model.newPhoto = reader.result;
            model.photo = reader.result;
            context.setState({ model: model, FileName: file.name });
        };
        reader.onerror = function (error) {
            alert("Error subiendo imagen, por favor inténtelo de nuevo.")
        };
    }

    selectedImage(e) {
        if (e.currentTarget.files.length > 0) {
            this.getBase64(e.currentTarget.files[0])
        }
    }

    render() {
        return (
            <div className="mt-5">

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                        <li class="breadcrumb-item"><a href="/comunidad/plan">Planes</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{this.state.model.id ? 'Edición plan' : 'Nuevo plan'}</li>

                        <li class="miga-more-option">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                            </svg>
                        </li>
                    </ol>
                </nav>

                <div class="accordion" id="accordionExample">
                    <div class="steps">
                        <div className="blocked"></div>
                        <progress id="progress" value="0" max="100" ></progress>
                        <div class="step-item">
                            <button id="stepOne"  class="step-button text-center" type="button" data-toggle="collapse"
                                data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                1
                            </button>
                            <div class="step-title">
                                Plan
                            </div>
                        </div>
                        <div class="step-item">
                            <button id="stepTwo"  class="step-button text-center collapsed" type="button" data-toggle="collapse"
                                data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                2
                            </button>
                            <div class="step-title">
                                Motivacionales
                            </div>
                        </div>
                        <div class="step-item">
                            <button id="stepThree"  class="step-button text-center collapsed" type="button" data-toggle="collapse"
                                data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                3
                            </button>
                            <div class="step-title">
                                Actividades
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div id="headingOne">
                        </div>

                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample">
                            <div class="card-body">
                                <div className="form-group text-center">
                                    <div class="card">
                                        {
                                            !this.state.model.photo ?
                                                <div class="drop_box">
                                                    <header>
                                                        <h4>Seleccione foto</h4>
                                                    </header>
                                                    <p>Archivos soportados: .jpg, .jpeg, .png, .gif</p>
                                                    <input type="file" hidden accept="image/*" id="fileID" style={{ "display": "none" }} onChange={(e) => { this.selectedImage(e) }} />
                                                    <button class="btn">Seleccionar foto</button>
                                                </div>
                                                :
                                                <div class="image-is-selected" >
                                                    <h4>{this.state.FileName}</h4>
                                                    <img src={this.state.model.photo} width="200px" />
                                                    <input type="button" className="btn btn-danger" value="Eliminar" onClick={(e) => {
                                                        var model = this.state.model;
                                                        model.photo = '';
                                                        this.setState({ model: model })
                                                    }} />
                                                </div>
                                        }


                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div className="col-12">
                                        <label for="title">Titulo</label>
                                        <input type="text" class="form-control" id="title" maxLength="100" value={this.state.model.title} onChange={e => {
                                            var model = this.state.model;
                                            model.title = e.currentTarget.value;
                                            this.setState({ model: model })
                                        }} />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div className="col-8">
                                        <label for="title">Creado por</label>
                                        <input type="text" class="form-control" id="author" maxLength="100" value={this.state.model.author} onChange={e => {
                                            var model = this.state.model;
                                            model.author = e.currentTarget.value;
                                            this.setState({ model: model })
                                        }} />
                                    </div>
                                    <div className="col-4">
                                        <label for="title">Pl número</label>
                                        <input type="number" class="form-control" id="pl" maxLength="9999" value={this.state.model.plNumber} onChange={e => {
                                            var model = this.state.model;
                                            model.plNumber = parseInt(e.currentTarget.value);
                                            this.setState({ model: model })
                                        }} />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div className="col-12">
                                        <label for="title">Descripción</label>
                                        <textarea class="form-control" id="description" maxLength="500" value={this.state.model.description} onChange={e => {
                                            var model = this.state.model;
                                            model.description = e.currentTarget.value;
                                            this.setState({ model: model })
                                        }}></textarea>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div className="col-12">
                                        <label>Tema</label>
                                        <ul>
                                            {
                                                this.state.topics.map((e, i) =>
                                                    <li class="list-group-item list-group-item-success">
                                                        <input type="checkbox" id={`cbxTopic${i}`} className="mr-3" checked={this.state.model.topics.find(c => c == e.id) != undefined} value={e.id} onClick={(e) => {

                                                            var model = this.state.model;

                                                            if (e.currentTarget.checked) {
                                                                model.topics.push(parseInt(e.currentTarget.value));
                                                            } else {
                                                                model.topics = model.Topics.filter(a => a != e.currentTarget.value)
                                                            }
                                                            this.setState({ model: model })

                                                        }} />
                                                        <label for={`cbxTopic${i}`} >{e.title}</label>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div className="col-12">
                                        <label for="title">Días para completar el plan</label>
                                        <select className="form-control" onChange={e => {
                                            var model = this.state.model;
                                            model.numberOfDays = parseInt(e.currentTarget.value);
                                            this.setState({ model: model })
                                        }}>
                                            <option value="0">Seleccione una opción</option>
                                            {
                                                (() => {
                                                    const arr = [];
                                                    for (let i = 0; i < 20; i++) {
                                                        arr.push(
                                                            <option value={i + 1} selected={this.state.model.numberOfDays == i + 1} >{i + 1}</option>
                                                        );
                                                    }
                                                    return arr;
                                                })()
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div className="col-12">

                                        {
                                            (document.referrer.indexOf('comunidad/plan/Administrar') != -1) ?
                                                <a className="btn btn-secondary" href="/comunidad/plan/Administrar">Atrás</a> :
                                                <a className="btn btn-secondary" href="/comunidad/plan">Atrás</a>
                                        }

                                        <input type="button" value="Siguiente" className="btn btn-primary" disabled={!this.state.model.title || !this.state.model.author || !this.state.model.plNumber || !this.state.model.description || !this.state.model.photo || this.state.model.numberOfDays == 0 || this.state.model.topics.length == 0} onClick={() => {
                                            this.AddOrUpdate();
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div id="headingTwo">

                        </div>
                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div class="card-body">
                                <ol class="list-group list-group-numbered">

                                    {
                                        this.state.Motivationals.map(a => <li class="list-group-item list-group-item-success" onClick={() => {
                                            this.GetActivitiesByMotivationalId(a.id);
                                            this.setState({ selectedMotivational: a });
                                            document.querySelector('#stepTwo').click();
                                            document.querySelector('#stepThree').click();
                                        }} >
                                            <div className="row">
                                                <div className="col-11">
                                                    Motivacional día {a.day}
                                                </div>
                                                {
                                                    a.description ?
                                                        <div className="col-1">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-all" viewBox="0 0 16 16">*/}
                                                                <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />*/}
                                                            </svg>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                        </li>)
                                    }

                                </ol>

                                <div class="form-group row">
                                    <div className="col-12">
                                        <input type="button" value="Atrás" className="btn btn-secondary" onClick={() => { document.querySelector('#stepTwo').click(); document.querySelector('#stepOne').click(); }} />



                                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter" disabled={this.state.Motivationals.filter(c => !c.description).length > 0} >
                                                                                    Enviar a revisión
                                        </button>

                                        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                            <div class="modal-dialog modal-dialog-centered" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleModalLongTitle">Confirmar plan</h5>
                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        Por favor revise que la foto y la ortografía estén correctas, si está seguro que todo está oooooookey, haga clic en "Sí, enviar".
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                                        <button type="button" class="btn btn-primary" data-dismiss="modal" onClick={() => { this.UpdateStatePlan(); }}>Sí, enviar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div id="headingThree">

                        </div>
                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample">
                            <div class="card-body">
                                {
                                    <h4>Motivacional día {this.state.selectedMotivational ? this.state.selectedMotivational.day : null}</h4>
                                }

                                <div className="col-12">
                                    <label for="title">* Descripción</label>
                                    <textarea class="form-control activities-input" data-is-motivational="true" value={this.state.selectedMotivational.description ? this.state.selectedMotivational.description : ''} maxLength="3000" onChange={e => {
                                        var model = this.state.selectedMotivational;
                                        model.description = e.currentTarget.value;
                                        this.setState({ selectedMotivational: model })
                                    }}></textarea>
                                </div>

                                {
                                    this.state.activities.map((a, i) =>
                                        <div className="row col-12">
                                            <div className="col-sm-10 col-11">
                                                <label for="title">Descripción</label>
                                                <textarea class="form-control activities-input" data-is-motivational="false" value={a.description} maxLength="3000" onChange={

                                                    h => {
                                                        var newValue = h.currentTarget.value;
                                                        var old = this.state.activities;
                                                        old[i].description = newValue;
                                                        this.setState({ activities: old });
                                                    }

                                                }></textarea>
                                            </div>
                                            <div className="col-sm-2 col-1" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16" onClick={(e) => {
                                                    e.currentTarget.parentElement.parentElement.remove();
                                                }} >
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                                </svg>
                                            </div>
                                        </div>
                                    )
                                }

                                <div class="form-group row">
                                    <div className="col-12">
                                        <input type="button" className="btn btn-outline-secondary" value="Agregar actividad" onClick={e => {
                                            var activities = this.state.activities;
                                            activities.push({ id: activities.length + 1, description: '' });
                                            this.setState({ activities: activities });
                                        }} />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <div className="col-12">
                                        <input type="button" className="btn btn-secondary" value="Atrás" onClick={e => {
                                            document.querySelector('#stepTwo').click();
                                            document.querySelector('#stepThree').click();
                                        }} />
                                        <input type="button" className="btn btn-primary" value="Guardar" onClick={e => {
                                            this.InsertActivitiesByPlan();
                                        }} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }}/> : null}
                {this.state.loading ? <Loading /> : null}
            </div >
        );
    }
}